export default __webpack_public_path__ + "static/media/jull.429e7870.jpg";